export const TAB_SELECTED_INSTANCE_KEY = 'tab_selected_instance';
export const MOST_RECENTLY_SELECTED_INSTANCE_KEY = 'browser_selected_instance';

// When accessing a url with an instanceUuid separate to the current instance, we only want to
// update the instance used by the current tab.
export function setSelectedInstanceStateForTab(selectedInstance: string): void {
    sessionStorage.setItem(TAB_SELECTED_INSTANCE_KEY, selectedInstance);
}

export function setSelectedInstanceState(selectedInstance: string): void {
    sessionStorage.setItem(TAB_SELECTED_INSTANCE_KEY, selectedInstance);
    localStorage.setItem(MOST_RECENTLY_SELECTED_INSTANCE_KEY, selectedInstance);
}

export function getSelectedInstanceState(): string | null {
    // This logic is so you can have multiple tabs open with different instances selected at the same time
    const sessionInstance = sessionStorage.getItem(TAB_SELECTED_INSTANCE_KEY);
    if (sessionInstance) {
        // return the current tabs selected instance
        return sessionInstance;
    }
    // return the browsers last selected instance
    return localStorage.getItem(MOST_RECENTLY_SELECTED_INSTANCE_KEY);
}

export function clearSelectedInstanceState(): void {
    sessionStorage.removeItem(TAB_SELECTED_INSTANCE_KEY);
    localStorage.removeItem(MOST_RECENTLY_SELECTED_INSTANCE_KEY);
}
